import React from 'react'
import { graphql } from 'gatsby'
import get from 'lodash/get'
import Helmet from 'react-helmet'
import Layout from '@layouts/layout'
import NotesPreview from '@components/notes-preview/notes-preview'

class NotesIndex extends React.Component {
  render() {
    const siteTitle = get(this, 'props.data.site.siteMetadata.title')
    const notes = get(this, 'props.data.allMarkdownRemark.edges')

    return (
      <Layout location={this.props.location}>
        <div>
          <Helmet title={siteTitle} />
          <div className="wrapper">
            <h2 className="section-headline">Jurnal Teknis</h2>
            <ul className="article-list">
              {notes.map(({ node }) => {
                return (
                  <li key={node.fields.slug}>
                    <NotesPreview
                      img={node.frontmatter.banner.childImageSharp.fluid}
                      title={node.fields.title}
                      excerpt={node.excerpt}
                      slug={`/notes/${node.fields.slug}`}
                    />
                  </li>
                )
              })}
            </ul>
          </div>
        </div>
      </Layout>
    )
  }
}

export default NotesIndex

export const pageQuery = graphql`
  query NotesndexQuery {
    site {
      siteMetadata {
        title
      }
    }
    allMarkdownRemark(
      filter: { fileAbsolutePath: { regex: "/notes/" } }
      sort: { fields: frontmatter___date, order: DESC }
    ) {
      edges {
        node {
          fields {
            categories
            date
            description
            id
            keywords
            slug
            title
          }
          frontmatter {
            banner {
              childImageSharp {
                fluid(maxWidth: 800) {
                  ...GatsbyImageSharpFluid
                }
              }
            }
          }
          excerpt
        }
      }
    }
  }
`
